import MenuItem, { MenuItemProps } from '@mui/material/MenuItem'
import { FC } from 'react'

export const SelectItem: FC<MenuItemProps> = ({ children, ...props }) => {
  return <MenuItem {...props}>{children}</MenuItem>
}
